import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { SortableElement } from 'react-sortable-hoc';
import keycode from 'keycode';
import DragHandle from '../../../../common/ui/DragHandle';
import { RenderField, RenderHiddenField } from '../../../../common/form';
import * as Validations from '../../../../common/form/commonValidations';


class RenderRsvpQuestion extends Component {
  constructor(props) {
    super(props);

    this.toggleEditing = this.toggleEditing.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleEnter = this.handleEnter.bind(this);

    this.state = {
      editing: false
    };
  }

  componentWillMount() {
    const { fieldIndex, fields } = this.props;
    const field = fields.get(fieldIndex);
    const { editing } = field;
    if (editing) {
      this.setState({
        editing: true
      });
    }
  }

  toggleEditing() {
    this.setState(prevState => ({
      editing: !prevState.editing
    }));
  }

  handleDelete(rsvpQuestionCount) {
    const { fieldIndex, fields, onDeleteRsvpQuestion } = this.props;
    const deleteAction = () => fields.remove(fieldIndex);
    if (rsvpQuestionCount) {
      const rsvpQuestion = fields.get(fieldIndex);
      onDeleteRsvpQuestion(rsvpQuestion, deleteAction);
    } else {
      deleteAction();
    }
  }

  handleBlur(e, newValue) {
    if (newValue !== '') {
      this.toggleEditing();
    }
  }

  handleEnter(e) {
    const { value } = e.target;
    if (keycode(e) === 'enter') {
      e.preventDefault();
      if (value !== '') {
        this.toggleEditing();
      }
    }
  }

  render() {
    const { rsvpQuestion, fieldIndex, fields, rsvpQuestionCounts } = this.props;
    const { editing } = this.state;

    const rsvpQuestionCount = rsvpQuestionCounts[fields.get(fieldIndex).id];

    return (
      <div className="sortable-rsvp-question-row">
        {editing ? (
          <div className="rsvp-question-row">
            <DragHandle tooltip="Drag to reorder" />
            <Field
              component={RenderHiddenField}
              name="suggested_rsvp_question_id"
            />
            <Field
              name={`${rsvpQuestion}.question`}
              component={RenderField}
              type="text"
              className="rsvp-question"
              placeholder="Any song requests?"
              validate={Validations.MAX_LENGTH_400}
              maxChars={400}
              hideFormGroup
              onBlur={this.handleBlur}
              onKeyDown={this.handleEnter}
            />
            <div role="button" className="rsvp-question-delete" onClick={() => this.handleDelete(rsvpQuestionCount)}>
              <i className="zolaicon zolaicon-trashcan" />
            </div>
            {rsvpQuestionCount && (
              <div className="rsvp-question-count rsvp-question-count-editing">
                {rsvpQuestionCount} {rsvpQuestionCount === 1 ? 'Answer' : 'Answers'}
              </div>
            )}
          </div>
        ) : (
          <div className="rsvp-question-row" style={{ position: 'relative' }}>
            <DragHandle tooltip="Drag to reorder" />
            <span className="rsvp-question rsvp-question-display">{fields.get(fieldIndex).question}</span>
            <div role="button" className="rsvp-question-edit" onClick={this.toggleEditing}>
              {/* <i className="glyphicon glyphicon-pencil" /> */}
              <i className="zolaicon zolaicon-edit" />
            </div>
            {rsvpQuestionCount && (
              <div className="rsvp-question-count">
                {rsvpQuestionCount} {rsvpQuestionCount === 1 ? 'Answer' : 'Answers'}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

RenderRsvpQuestion.propTypes = {
  rsvpQuestion: PropTypes.string,
  fieldIndex: PropTypes.number,
  fields: PropTypes.shape({}),
  rsvpQuestionCounts: PropTypes.shape({}),
  onDeleteRsvpQuestion: PropTypes.func,
};

const SortableRsvpQuestion = SortableElement(props => <RenderRsvpQuestion {...props} />);


export default SortableRsvpQuestion;



/** WEBPACK FOOTER **
 ** ./src/components/manage/common/EventForm/SortableRsvpQuestions/SortableRsvpQuestionField.jsx
 **/